import React from 'react';
import { useEditSceneModalPlaybackContext } from '../EditSceneModalPlaybackContext';
import EditScenePreviewPlaybar from './EditScenePreviewPlaybar';
import EditScenePreviewPlayer from './EditScenePreviewPlayer';
import usePlayClip from './usePlayClip';

export type EditScenePreviewControllerProps = {};

const EditScenePreviewController: React.FC<EditScenePreviewControllerProps> = () => {
  const { playerRef } = useEditSceneModalPlaybackContext();

  const {
    currentTime,
    duration,
    isPlaying,
    handlePlaybackChange,
    handlePlaybarSeek,
    handlePlaybarSeekEnd,
    handleTimeupdate,
  } = usePlayClip();

  return (
    <>
      <EditScenePreviewPlaybar
        {...{ currentTime, duration, isPlaying }}
        onPlaybackChange={handlePlaybackChange}
        onSeek={handlePlaybarSeek}
        onSeekEnd={handlePlaybarSeekEnd}
      />
      <EditScenePreviewPlayer onTimeupdate={handleTimeupdate} ref={playerRef} />
    </>
  );
};

export default EditScenePreviewController;
